import { createSvg } from '@r1-frontend/ui-react/components/svg/createSvg';
var SingleArrowUp = function (_a) {
    var _b = _a.strokeWidth, strokeWidth = _b === void 0 ? 1.5 : _b;
    return (<g id={'guts'}>
            <path d='M19.9201 15.05L13.4001 8.53C12.6301 7.76 11.3701 7.76 10.6001 8.53L4.08008 15.05' strokeWidth={strokeWidth} strokeMiterlimit='10' strokeLinecap='round' strokeLinejoin='round'/>
        </g>);
};
export default createSvg(SingleArrowUp, 'single-arrow-up');
